module.exports = __webpack_public_path__ + "static/media/facebook.c95af783.svg";